/** The tenant's own bookings list. Mounted as `/bookings/*` in the router. */
export const BOOKINGS_PATH = '/bookings';
export const CHECKOUT_PATH = '/checkout';
export const QUICK_CHECKOUT_PATH = '/quick-checkout';
export const RECEIPT_PATH = '/receipt';
/*
 * RES-1407 — where every checkout lands under the 2-way chat redesign instead of `receipt`: the route
 * that decides between the add-on offer (Booking confirmed) and My bookings, without the old receipt.
 * A nested SEGMENT, like `receipt`, so it inherits every prefix PaymentContent is mounted under.
 */
export const BOOKING_COMPLETED_SEGMENT = 'booked';
export const HISTORICAL_RECEIPT_PATH = '/historical-receipt';
// RES-999: de-modal booking details. Numeric transaction id (details.id), matching the id already
// threaded through the my-bookings click flow — not the transaction uuid (that's the separate
// existing deep-link route at receipt/:transactionUuid).
export const BOOKING_DETAILS_PATH = '/booking-details/:transactionId';
// Encode the id — react-router-dom's matcher decodeURIComponent()s each path param before handing
// it back via useParams(), so this round-trips transparently for the plain numeric/string ids this
// app actually uses; it just also keeps a "/", "?", or "#" (however unlikely for a details.id) from
// splitting into extra path segments / a query string instead of staying part of this one segment.
export const getBookingDetailsPath = (transactionId: number | string): string =>
  `/booking-details/${encodeURIComponent(transactionId)}`;
